import * as React from 'react';

import { IconProps } from './IconProps';
import { SVGWrapper } from './SVGWrapper';

export const ToolsLine: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style} viewBox="0 0 17 17" fill="none">
    <path
      d="M2.8847 0.498927C4.01503 0.0970787 5.32566 0.348511 6.23039 1.25323C7.2579 2.28073 7.44279 3.83177 6.78501 5.04767L16.6013 14.865L15.3049 16.1614L5.48839 6.34467C4.27238 7.00297 2.72086 6.81826 1.69312 5.7905C0.788138 4.88553 0.536815 3.57441 0.939149 2.44386L2.98949 4.49415C3.52645 5.03111 4.39705 5.03111 4.93403 4.49415C5.47099 3.95717 5.47099 3.08657 4.93403 2.5496L2.8847 0.498927ZM12.3881 2.22551L15.3049 0.605059L16.6013 1.90142L14.9808 4.81823L13.3604 5.14232L11.4158 7.08684L10.1195 5.7905L12.064 3.84596L12.3881 2.22551ZM6.23039 9.67955L7.52676 10.976L2.66539 15.8373C2.30741 16.1953 1.72701 16.1953 1.36903 15.8373C1.03662 15.5049 1.01288 14.9807 1.2978 14.6209L1.36903 14.541L6.23039 9.67955Z"
      fill={color || '#315DC3'}
    />
  </SVGWrapper>
);
